import { motion } from "framer-motion";
import { Phone, MessageSquare, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE, TEL, SMS, EASE } from "./data";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative overflow-hidden">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[var(--signal)] opacity-[0.1] blur-[140px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 py-28 sm:px-8 lg:py-40">
      <Reveal>
        <p className="mb-8 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">
          <span className="text-[var(--signal)]">08</span><span className="h-px w-10 bg-[var(--line)]" /> Dispatch
        </p>
      </Reveal>
      <motion.a href={TEL} data-testid="contact-big-phone" className="group block" initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
        <span className="block overflow-hidden">
          <motion.span
            className="block whitespace-nowrap font-display text-[14vw] font-black leading-[0.85] tracking-tight transition-colors duration-500 group-hover:text-[var(--signal)] lg:text-[12vw] 2xl:text-[200px]"
            variants={{ hidden: { y: "100%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, ease: EASE }}
          >
            {PHONE}
          </motion.span>
        </span>
      </motion.a>
      <Reveal delay={0.15} className="mt-12 flex flex-col gap-8 border-t border-[var(--line)] pt-10 lg:flex-row lg:items-end lg:justify-between">
        <p className="max-w-lg text-base leading-relaxed text-zinc-300 sm:text-lg">
          Property manager with a parking problem, or looking for your vehicle — one number reaches Warrior dispatch.
        </p>
        <div className="flex flex-wrap gap-3">
          <a href={TEL} data-testid="contact-call-btn" className="group flex min-h-[52px] items-center gap-3 bg-[var(--signal)] px-6 font-display text-xl font-extrabold uppercase text-[var(--ink)] transition-transform duration-300 hover:-translate-y-1">
            <Phone className="h-5 w-5" strokeWidth={2.5} /> Call now <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a href={SMS} data-testid="contact-text-btn" className="flex min-h-[52px] items-center gap-3 border border-[var(--line)] px-6 font-display text-xl font-extrabold uppercase transition-colors duration-300 hover:border-[var(--signal)]">
            <MessageSquare className="h-5 w-5 text-[var(--signal)]" /> Text us
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
